function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M63.841,6.869A40.886,40.886,0,0,0,34.637.522,3.513,3.513,0,0,0,34.1.573,41.039,41.039,0,0,0,.677,48.025,42,42,0,0,0,1.97,53.347,30.706,30.706,0,0,1,.4,75.505,3.418,3.418,0,0,0,4.4,80.259L19.73,76.073a40.678,40.678,0,0,0,21.3,6.029,41.312,41.312,0,0,0,8.184-.821A41.042,41.042,0,0,0,63.841,6.869ZM69.6,59.985a34.194,34.194,0,0,1-47.415,9.542,3.411,3.411,0,0,0-2.8-.448L8.95,71.928A37.63,37.63,0,0,0,8.5,51.316a34.839,34.839,0,0,1-1.084-4.46A34.2,34.2,0,0,1,34.819,7.4a3.953,3.953,0,0,0,.489-.051A34.2,34.2,0,0,1,69.6,59.985Z",
  transform: "translate(-0.064 0)"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(37.634 20.189)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M238.181,125.909a3.417,3.417,0,0,0-3.42,3.42v20.52a3.42,3.42,0,1,0,6.84,0v-20.52A3.417,3.417,0,0,0,238.181,125.909Z",
  transform: "translate(-234.761 -125.909)"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(37.634 54.726)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M241.325,343.407a3.189,3.189,0,0,0-.718-1.129,3.262,3.262,0,0,0-.547-.41,3.705,3.705,0,0,0-1.231-.513,3.417,3.417,0,0,0-3.075.923,3.193,3.193,0,0,0-.718,1.129,3.224,3.224,0,0,0,0,2.6,3.084,3.084,0,0,0,1.847,1.847,3.215,3.215,0,0,0,2.6,0,3.993,3.993,0,0,0,1.129-.718,3.95,3.95,0,0,0,.718-1.129,3.224,3.224,0,0,0,0-2.6Z",
  transform: "translate(-234.762 -341.284)"
}));

var SvgAttention = function SvgAttention(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 82.081 82.102",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAttention, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/attention.8c76f3a4.svg";
export { ForwardRef as ReactComponent };